import React from "react";
import "./StartBtn.css";
import "@fontsource/roboto";
import "@fontsource/roboto/700.css";

const StartBtn = ({ onClick, name }) => {
  return (
    <div className="btn-container">
      <button
        className="start-btn-compo"
        onClick={onClick}
        style={{
          fontFamily: "Roboto",
        }}
      >
        {name}
      </button>
    </div>
  );
};

export default StartBtn;
